import { AnalyticsEvent } from "Shared/services/analytics/config";
import {
  ANALYTICS_EVENT_ATTRIBUTES,
  ANALYTICS_EVENT_NAMES,
  ANALYTICS_EVENT_SUB_TYPE,
  ANALYTICS_EVENT_TYPE,
} from "Shared/services/analytics/constants";
import { GA4_EVENT_CATEGORY, trackEventConditionally } from "Shared/services/analytics/services/thresholdManager";

export enum DYNAMIC_SCREENER_END_RESPONSE_CODES {
  SUCCESS = 200,
  ERROR = 400,
  DISQUALIFIED = 400,
  CANCEL = 499
}

export enum DYNAMIC_SCREENER_END_RESPONSE_MESSAGES {
  SUCCESS = 'success',
  ERROR = 'error',
  DISQUALIFIED = 'disqualified',
  CANCEL = 'cancel'
}

/**
 * Sends analytic event for completing a dynamic screener survey
 * @param subType The sub type of the event
 * @param id The survey ID
 * @param providerId The provider ID
 * @param totalSteps Total number of screening questions
 * @param responseCode The response code (200 = success, 400 = error/disqualified, 499 = cancel)
 * @param responseMessage The response message
 * @returns void
 */
export const analyticsTrackDynamicScreenerEnd = (
  id             : string,
  providerId     : string,
  totalSteps     : number,
  responseCode   : DYNAMIC_SCREENER_END_RESPONSE_CODES,
  responseMessage: DYNAMIC_SCREENER_END_RESPONSE_MESSAGES
): void => {
  const event: AnalyticsEvent = {
    event: ANALYTICS_EVENT_NAMES.end,
    attributes: {
      [ANALYTICS_EVENT_ATTRIBUTES.type]            : ANALYTICS_EVENT_TYPE.questionnaire,
      [ANALYTICS_EVENT_ATTRIBUTES.sub_type]        : ANALYTICS_EVENT_SUB_TYPE.survey_dynamic_screener,
      [ANALYTICS_EVENT_ATTRIBUTES.id]              : id,
      [ANALYTICS_EVENT_ATTRIBUTES.provider_id]     : providerId,
      [ANALYTICS_EVENT_ATTRIBUTES.total_steps]     : totalSteps,
      [ANALYTICS_EVENT_ATTRIBUTES.response_code]   : responseCode,
      [ANALYTICS_EVENT_ATTRIBUTES.response_message]: responseMessage,
    }
  };

  trackEventConditionally(GA4_EVENT_CATEGORY.dynamic_screener, [event]);
};
